//---------------- IMPORTAÇÕES ----------------//
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx' // Importação do AppRoutes
import './index.css' // Importação dos estilos css
import { SidebarProvider } from "./shared/context/SidebarContext"; // Importação do Contexto Sidebar
import { LoadingProvider } from './shared/context/LoadingContext.jsx';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';



//---------------- CRIAÇÃO DA APLICAÇÃO REACT ----------------//
ReactDOM.createRoot(document.getElementById('root')).render(
  <>
    {/* CONTAINER DO MODO DE DESENVOLVIMENTO */}
    <React.StrictMode>

      {/* CONTAINER QUE HABILITA A NAVEGAÇÃO ENTRE ROTAS */}
      <BrowserRouter>

        {/* CONTAINER QUE HABILITA O CONTEXTO SIDEBAR EM TODA A APLICAÇÃO */}
        <SidebarProvider>

          {/* CONTAINER DE POPUPS TOAST */}
          {/* ÚNICO ToastContainer da aplicação. Containers locais nas páginas sobrescreviam o registro
              (chave 1 da store do react-toastify) e, ao desmontar, apagavam — toasts ficavam na fila
              até a próxima página com container montar. Não adicionar outros. */}
          <ToastContainer theme="dark" position="top-right" newestOnTop limit={6} autoClose={5000} />

          {/* CONTAINER QUE HABILITA O CONTEXTO LOADING EM TODA A APLICAÇÃO */}
          <LoadingProvider>
            
            {/* APLICAÇÃO REACT */}
            <App />

          </LoadingProvider>

        </SidebarProvider>

      </BrowserRouter>

    </React.StrictMode>
  </>
)

